import React, { useContext, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { get } from "lodash";
import { Link } from "react-router-dom";
import {
  ManagePlanMenu,
  LoaderWrapper,
  PlanLeftPanelDetails,
} from "../../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/pro-light-svg-icons";
import { withAppLayout } from "../../../hoc";
import { managePlanFormNames, MANAGE_PLAN_MENU, ROUTES } from "../../../utils";
import { ManagePlanRoutes } from "../../../routes";
import {
  createPlanStore,
  CreatePlanProvider,
  setManagePlanSelectedMenu,
} from "../../../contexts";

export const ManagePlan = (props) => {
  const { location } = props;
  const { state, dispatch } = useContext(createPlanStore);
  const { isFetching } = get(state, "api", {});
  const planId = get(state, "planId");
  const companyId = get(state, "api.data.companyId");
  const flow = get(state, "flow");
  // enven to handle location change
  useEffect(() => {
    dispatch(setManagePlanSelectedMenu(location.pathname));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const planName = get(
    state,
    `${managePlanFormNames.CREATE_PLAN}.planName`,
    ""
  );
  const isLoading = get(state, "isLoading");
  const apiData = get(state, "api.reviewAndPlanDetail", {});
  const reviewDetails = get(apiData, "review", {});
  const planStatus = get(apiData, "planStatus", {});
  const completedModules = ["irslimit"];
  if (reviewDetails !== null) {
    Object.keys(reviewDetails).forEach((key) => {
      if (reviewDetails[key]) {
        completedModules.push(key);
      }
    });
  }
  return (
    <LoaderWrapper
      isLoading={isLoading || isFetching}
      className="row manage-company-wrapper"
    >
      <Col className="h-100">
        <Row sm="12" className="h-100">
          <Col
            className="manage-company-column manage-menu-items"
            style={{ maxWidth: "20%" }}
          >
            <Link className="manage-company-menu-back-button" to={ROUTES.PLAN}>
              <FontAwesomeIcon icon={faArrowLeft} />
              <span className="manage-company-menu-back-button-label">
                Back
              </span>
            </Link>
            <div className="company-name-component">
              <PlanLeftPanelDetails {...apiData} />
            </div>
            <ManagePlanMenu
              menuList={
                planStatus == 3 && completedModules.includes("review")
                  ? MANAGE_PLAN_MENU.filter((item, ind) => {
                      return item.id != "review";
                    })
                  : MANAGE_PLAN_MENU
              }
              selectedMenu={get(state, "selectedMenu")}
              planId={planId}
              companyId={companyId}
              flow={flow}
              completedModules={completedModules}
            />
          </Col>
          <Col
            className="manage-menu-content"
            style={{ maxWidth: "75%", height: "100vh" }}
          >
            <ManagePlanRoutes planName={planName} />
          </Col>
        </Row>
      </Col>
    </LoaderWrapper>
  );
};

const ManagePlanWithProvider = (props) => {
  return (
    <CreatePlanProvider>
      <ManagePlan {...props} />
    </CreatePlanProvider>
  );
};

export default withAppLayout(ManagePlanWithProvider);
